module.exports = __webpack_public_path__ + "img/MC-Logo-White.e592615.png";